export const IconUsers20: {
  name: 'icon_users_20-cc3b8f19868e'
} = {
  name: 'icon_users_20-cc3b8f19868e'
}
